import { StateCreator } from "zustand";

import { Media } from "../../types/player-api";
import { StoreMiddlewares } from "../storeTypes";

export type ApiDataSliceState = {
  aspectRatio: string | undefined;
  contentType: string;
  embedId: string | undefined; // For simulcasts, for example "yle-tv1" or "ylex", for webcasts and ondemands, it is the programId
  isAudio: boolean;
  isFakeOnDemand: boolean;
  isLive: boolean;
  isSimulcast: boolean;
  media: Media | undefined;
  mediaId: string | undefined;
  mediaLoadingStartTimestamp: number | undefined; // ms since epoch
  programId: string | undefined; // For simulcasts, it is the current running program id, for webcasts and ondemands same as the embedId
  publicationId: string | undefined;
  publicationType: string | undefined;
  serviceId: string;
};

type ApiDataSliceAction = {
  setAspectRatio: (AspectRatio: string) => void;
  setEmbedId: (embedId: string) => void;
  setMediaLoadingStartTimestamp: (mediaLoadingStartTimestamp: number) => void;
};

export type ApiDataSlice = ApiDataSliceState & ApiDataSliceAction;

export const API_DATA_SLICE_DEFAULTS: ApiDataSliceState = {
  aspectRatio: undefined,
  contentType: "VideoObject",
  embedId: undefined,
  isAudio: false,
  isFakeOnDemand: false,
  isLive: false,
  isSimulcast: false,
  media: undefined,
  mediaId: undefined,
  mediaLoadingStartTimestamp: undefined,
  programId: undefined,
  publicationId: undefined,
  publicationType: undefined,
  serviceId: "yle-areena"
};

export const apiDataSlice: StateCreator<
  ApiDataSlice,
  StoreMiddlewares
> = set => ({
  ...API_DATA_SLICE_DEFAULTS,
  setAspectRatio: aspectRatio => set({ aspectRatio }, false, "setAspectRatio"),
  setEmbedId: embedId => set({ embedId }, false, "setEmbedId"),
  setMediaLoadingStartTimestamp: mediaLoadingStartTimestamp =>
    set({ mediaLoadingStartTimestamp }, false, "setMediaLoadingStartTimestamp")
});
